import Button from '~components/Button/Button';
import ZipForm from '~components/ZipCodeForm/ZipCodeForm';

const ZipWithGuidedFlow = ({ pageFilter }: { pageFilter?: string }) => {
    return (
        <section className="hero-paid-search-zip-with-guided-flow">
            <div className="bg-surface-light md:bg-transparent p-4 md:p-0 mt-0 lg:mt-6 rounded-lg drop-shadow-elevation-shadow-overlay md:filter-none flex justify-center">
                <div className="max-w-screen-xs md:max-w-screen-xl w-full">
                    <div className="mb-6 md:mb-2 lg:my-6">
                        <ZipForm
                            buttonTitle="Help me find a plan"
                            buttonTitleMobile="Help me choose"
                            buttonWaLink="Hero Guided Flow: help me find a plan"
                            qaValue="HeroGuidedFlow"
                            opts={{
                                btnStyle: 'primary',
                                useWideLayout: true,
                            }}
                            redirect={{
                                toUrl: process.env.GATSBY_EHIM_GUIDED_FLOW_URL,
                                delay: 500,
                            }}
                        />
                    </div>

                    <div>
                        <p className="text-center md:text-start hidden">
                            The doctors you have, prescriptions you need and benefits you want
                            &mdash; compare plans and enroll with no fee or obligation.
                        </p>

                        <div className="grid grid-cols-12">
                            <div className="col-span-12 md:col-span-8 lg:col-span-6">
                                <Button
                                    islink
                                    forceATag
                                    href={process.env.GATSBY_EHMP_URL}
                                    data-wa-link="Hero Guided Flow: compare plan"
                                    styletype="secondary"
                                    data-filter={pageFilter}
                                >
                                    Compare all plans
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ZipWithGuidedFlow;
